import { useSelector } from "react-redux";

export function useGetProfileDetails() {
  const { user } = useSelector((state: any) => state.auth);

  const onboardingData = useSelector(
    (state: any) => state.bidderAuth.onboarding,
  );

  const userProfileMobileNumber =
    user?.attributes?.find((number: any) => number?.type === "mobile_number")
      ?.value || "";

  const userProfileEmail =
    user?.attributes?.find((number: any) => number?.type === "email")?.value ||
    "";

  const userProfileName =
    onboardingData?.name ||
    user?.profile?.name ||
    user?.profile?.bio?.full_name ||
    "";

  const userProfilePicture = user?.profile?.profile_picture;

  return {
    name: userProfileName,
    email: userProfileEmail,
    mobile: userProfileMobileNumber,
    picture: userProfilePicture,
  };
}
